import { render, staticRenderFns } from "./PeChips.vue?vue&type=template&id=344585ff&"
import script from "./PeChips.vue?vue&type=script&lang=js&"
export * from "./PeChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports